import { Card } from 'antd';
import React, { useState } from 'react';

import FormEdit from '../../components/Forms/FormEdit/FormEdit';
import FormAdd from '../../components/Forms/FormAdd/FormAdd';
import AllForms from '../../components/Forms/AllForms/AllForms';

import styles from './MainPage.module.css';

const tabList = [
    {
        key: 'add',
        tab: 'Добавить форму',
    },
    {
        key: 'delete',
        tab: 'Изменить форму',
    },
    {
        key: 'forms',
        tab: 'Формы',
    },
];

const contentList = {
    add: <FormAdd />,
    delete: <FormEdit />,
};

export default function MainPage({ user }) {
    const [activeTabKey1, setActiveTabKey1] = useState('add');

    const onTab1Change = key => {
        setActiveTabKey1(key);
    };

    return (
        <div className={styles.mainContent}>
            <Card
                style={{
                    margin: '0 50px',
                    minWidth: 254,
                    maxWidth: 1124,
                    width: '100%',
                    height: 'fit-content',
                }}
                tabList={tabList}
                activeTabKey={activeTabKey1}
                onTabChange={key => {
                    onTab1Change(key);
                }}
            >
                <>
                    {activeTabKey1 === 'add' && <FormAdd />}
                    {activeTabKey1 === 'delete' && <FormEdit />}
                    {activeTabKey1 === 'forms' && <AllForms user={user} />}
                </>
            </Card>
        </div>
    );
}
